<template>
  <v-app>
    <notifications-display/>
    <router-view></router-view>
  </v-app>
</template>

<script>
    import NotificationsDisplay from "@/components/NotificationsDisplay";
    export default {
        name: "Index",
      components: {NotificationsDisplay}
    }
</script>
